import { updateVideoModalIntent } from "@/store/slices/video";
import Shimmer from "@/utils/shimmer";
import Image from "next/image";
import { SyntheticEvent } from "react";
import { useDispatch } from "react-redux";
import LinkWrapper from "../LinkWrapper";
import PlayIcon from "../SVG/PlayIcon";
import { IThumbnailListItem } from "./interfaces";


const ThumbnailListItem = (props: {item: IThumbnailListItem}) => {
  const item = props.item;
  const dispatch = useDispatch();
  const handleClick = (e: SyntheticEvent) => {
    if(item.href) return;
    e.preventDefault();
    dispatch(updateVideoModalIntent({ question_id: item.question_id, answer_id: item.answer_id}))
  }

  return <LinkWrapper onClick={handleClick} className={`snap-center shrink-0 sm:shrink w-72 sm:w-full ${item.className}`} href={item.href ? item.href : "#"}>
    <div className="relative">
      <Image className="m-0 w-full rounded-md" src={item.imgUrl} width={300} height={200} alt={item.alt ?? ""} placeholder="blur" blurDataURL={Shimmer(300, 200)}/>
      <PlayIcon className="absolute-center w-10 sm:w-12" />    
    </div>   
  </LinkWrapper>
};

export default ThumbnailListItem;